import { ConditionMultiValue } from './ConditionMultiValue';
import { ConditionMultiValueProps } from '../types';

export const ConditionMultiValueStringInput = (props: ConditionMultiValueProps<string>) => (
  <ConditionMultiValue {...props} isMultiInput />
);

export const ConditionMultiValueNumberInput = (props: ConditionMultiValueProps<string>) => (
  <ConditionMultiValue {...props} isMultiInput />
);

export const ConditionMultiValueStringSelect = (props: ConditionMultiValueProps<string>) => (
  <ConditionMultiValue {...props} />
);

export const ConditionMultiValueNumberSelect = (props: ConditionMultiValueProps<string>) => (
  <ConditionMultiValue {...props} />
);
